import { useState } from 'react'
import {
  cn,
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
  XIcon,
} from 'oddle-shop-monorepo.design-system'
import Button from '@/components/common/Button'

import {
  getStateStyles,
  InlineNotification,
} from '@/components/common/InlineNotification'

const NotificationBanner = () => {
  const [visible, setVisible] = useState(true)

  return (
    <div
      id="notification-banner-container"
      className={cn('hidden w-full', visible ? 'mb-3 mt-3' : '')}
    >
      <Collapsible
        open={visible}
        onOpenChange={setVisible}
        className="relative"
      >
        <CollapsibleTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className={cn(
              'absolute right-1.5 top-1.5 z-[1] !h-6 !w-6 !p-1.5',
              getStateStyles('warning', true).container
            )}
          >
            <XIcon className="!h-4 !w-4" />
          </Button>
        </CollapsibleTrigger>
        <CollapsibleContent className="relative w-full">
          <InlineNotification lightTheme={false} state="warning">
            <p
              id="notification-banner-primary-text"
              className="m-0 mr-3 text-black"
            />
            <p
              id="notification-banner-secondary-text"
              className="m-0 mr-3 text-black"
            />
          </InlineNotification>
        </CollapsibleContent>
      </Collapsible>
    </div>
  )
}

export default NotificationBanner
